// extracted by mini-css-extract-plugin
export default {"dropdown":"qy8QZXMlGv1ybZsJE5LG"};